<template>
  <div class="fColumn">
    <!--<slot></slot>-->
    <div class="fColumn">

      <!--<div class="tab-pane " id="tab3" role="tabpanel" aria-labelledby="tab3-tab">-->
      <h3>
        <button type="button" class="btn btn-success  btn-reprint float-right" v-on:click="$eventBus.$emit('globalChooseProductSearcher', {type:'ProductSearcherMass'})" v-if="hasBackButton==='true'">
          <i class="fa fa-angle-double-left"></i> {{$t('global.back')}}
          <!--{{$t('productTabs.sellAsCategory')}}-->
        </button>
        {{$t('businesspartnersearcher.title')}}
      </h3>
      <br>
      <!--<div class="col col-3 col-md-2">-->
      <!--&lt;!&ndash;<button type="button" class="btn btn-info btn-smXall btn-search " v-on:click="clickToSearch">&ndash;&gt;-->
      <!--&lt;!&ndash;<i class="fa fa-search"></i> Keresés&ndash;&gt;-->
      <!--&lt;!&ndash;</button>&ndash;&gt;-->
      <!--</div>-->
      <!--<div class="buyerInputsContainer col col-3 col-md-4 col-xs-3 extensionLine"><label for="buyerSearcherSid" class=" form-control-label font-size-large">-->
      <!--<small>{{$t('buyerSearcher.buyerId')}}</small>-->
      <!--</label></div>-->
      <!--col col-6 col-md-6-->
      <div class="buyerInputsContainer fColumn">
                <span class="businesspartnerContainer">
                    <!--{{businesspartner.businesspartnername}} {{businesspartner.taxnumber}}-->
                </span>
        <!--<div class="input-group">-->

        <!--<template v-if="justDisplay==='false'">-->

        <!--<div class="input-group-btn" v-if="buyer.id" v-on:click="buyerDisplayerOn"><span class="btn btn-success"><i class="fa fa-user"></i></span></div>-->
        <!--<div class="input-group-btn" v-if="!buyer.id" v-on:click="buyerDisplayerOn"><span class="input-group-addon btn btn-secondary"><i class="fa fa-user"></i></span></div>-->

        <!--<a style="flex: 0.01 1;" class="btn_keyboard input-group-addon" v-on:click="clickToOpenKeyboard" v-if="justDisplay=='false'">-->
        <!--<div class=" "><i class="fa fa-keyboard-o"></i></div>-->
        <!--</a>-->
        <!--</template>-->

        <!--<template v-if="buyerDisplayer">-->
        <!--<input class="form-control" readonly :value="buyerData" v-on:click="buyerDisplayerOff" >-->

        <!--</template>-->
        <!--<template v-if="!buyerDisplayer">-->

        <!--<InputText :title="$t('buyerSearcher.buyerId')" style="flex: 1 1 0;" :disabled="disabled" :readonly="readonly" id="buyerSearcherSid" className="form-control " isAccept="true"-->
        <!--isChange="true" :hasToKeyboard="hasKeyboard" :value="sid" v-model="sid" placeholder="" dataLayout="t" :onblur="onblur"/>-->

        <!--</template>-->


        <!--<a style="flex: 0.01 1;" class="btn_del_input input-group-addon pointer" data-id="0" v-on:click="clickToClear" v-if="justDisplay=='false'">-->
        <!--<div class=" "><i class="fa fa-times"></i></div>-->
        <!--</a>-->

        <!--<template v-if="buyer.discount">-->
        <!--<div style="flex: 0.02 0 0;" class="input-group-addonX discount_type_container discount_type btn btn-danger ">{{buyer.discount}}<span v-if="buyer.discount">%</span></div>-->
        <!--</template>-->
        <!--<template v-if="!buyer.discount">-->
        <!--<div style="flex: 0.02 0 0;" class="input-group-addon discount_type_container discount_type">{{buyer.discount}}<span v-if="buyer.discount">%</span></div>-->
        <!--</template>-->

        <!--</div>-->


        <div class="fContentFullAuto">
          <TableDatatableJs :head="head" :data="data"/>
        </div>


      </div>
      <!--col-9-->
      <!--<div class="">-->
      <!--<input type="text" id="searchText" name="searchText" placeholder="" class="form-control search d-none">-->
      <!--<label class="buyerData">{{buyerData}}</label>-->
      <!--</div>-->
    </div>
    <!--<div class="row searchResultContainer">-->
    <!--<div class=" searchResult d-none">-->
    <!--<table class="datatablex Xdisplay  table Xtable-striped Xtable-bordered" style="width: 100%"></table>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
  import i18n from '@/i18n';
  import Helper from '@/helper/Helper';
  import InputText from '@/components/InputText.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import Api from '@/api/Api';

  export default {
    name: 'BusinessPartnerSearcher',
//        roles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    data() {
      const modul = this;
      return {
        hasKeyboard: "false",
        disabled: "false",
        readonly: "false",

        Helper: Helper
        ,

        businesspartner: {
          id: null,
          businesspartnername: "",
          taxnumber: "",
          taxnumbercountrygroup: "",
          taxnumberother: "",
          registrationnumber: "",
          bank_account: "",
          dt: null,
          zip: "",
          public_space: "",
          nature_of_public_space: "",
          house_number: "",
          building: "",
          staircase: "",
          floor: "",
          door: "",
          county: "",
          city: "",
          country: "",
          phone_def: "",
          email_def: "",
          deleted: 0,
        },
        data: [],
        head: [
//                    {
//                        title: "businesspartnersearcher.select",
//                        data: "id",
//                        link: true,
//                        linkclass: "text-nowrap",
//                        linkurl: "selstore",
//                        linkiconclass: "menu-icon fa fa-briefcase",
//                        linktext: "businesspartnersearcher.selectpartner",
//                    }
//                    ,
          {
            key: "id",
            title: "businesspartner.action",
            linkclass: "text-nowrap",
            linktext: "businesspartner.linktext",
            linkiconclass: "menu-icon fa fa-briefcase",
            data: "id",
            linkfn: function (e, data, type, row, meta) { // data, type, row, meta
              return modul.setPartner(e, data, type, row, meta);
            }
          }
          , {
            key: "businesspartnername",
            title: "businesspartner.businesspartnername"
          }
          , {
            key: "taxnumber",
            title: "businesspartner.taxnumber"
          }
          , {
            key: "taxnumbercountrygroup",
            title: "businesspartner.taxnumbercountrygroup"
          }
          , {
            key: "id",
            title: "global.address",
            data: "id",
            render: function ( data, type, row, meta) { // data, type, row, meta
              return modul.displayAddress( data, type, row, meta);
            }
          }

//          , {
//            key: "registrationnumber",
//            title: "businesspartner.registrationnumber"
//          }
//          , {
//            key: "discount",
//            title: "businesspartner.discount"
//          }
//          , {
//            key: "zip",
//            title: "businesspartner.zip"
//          }
//          , {
//            key: "public_space",
//            title: "businesspartner.public_space"
//          }
//          , {
//            key: "county",
//            title: "businesspartner.county"
//          }
//          , {
//            key: "city",
//            title: "businesspartner.city"
//          }
          , {
            key: "phone_def",
            title: "businesspartner.phone_def"
          }
          , {
            key: "email_def",
            title: "businesspartner.email_def"
          }
        ]
      };
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          this.getElements();
        }
      },

    },
    props: {
      justDisplay: {
        type: String,
        default: "false",
      },
      hasBackButton: String,
    },
    mounted() {
      const modul = this;
//            modul.$eventBus.$on('globalSetBuyerSid', this.globalReadBuyerSidEventHandler);
      modul.state = Object.assign({}, modul.$store.state);
      modul.getAndSetBusinessPartners();
    },
    beforeDestroy() {
      const modul = this;
//            this.$eventBus.$off('globalSetBuyerSid');
    },
    methods: {
      setPartner: function (e, data, type, row, meta) {
        const modul = this;
        modul.$eventBus.$emit('globalSetBusinessPartner', row);
      },
      displayAddress: function ( data, type, row, meta) {
        const modul = this;
        return row.zip + " " + row.city + " " + row.public_space + " " + row.nature_of_public_space + " " + row.house_number + " ";
      },
      getAndSetBusinessPartners(){
        const modul = this;
        return Api.getBusinessPartners({id_company: modul.$store.state.id_company}).then(function (res) {
          console.log(res);
          if (res && res.result) {
            modul.data = res.data;
          }
        });
      },
    },
    components: {
      InputText,
      TableDatatableJs,
    },
  };
</script>

<style>


</style>

